import React from "react";

const VisionMission = () => {
  return (
    <div className="container visionmission">
      <div className="text-center mb-5">
        <h6 className="section-title bg-white text-center text-primary px-3">
          Our Aspirations
        </h6>
        <h2 className="mb-4">Vision & Mission</h2>
      </div>
      <div className="row my-5 d-flex justify-content-center">
        <div className="card col-lg-4 p-5">
          <div className="vision_img my-4"></div>
          <p>
            To create a skilled workforce that is technically proficient,
            professionally confident, and globally competitive by delivering
            comprehensive IT education and placement solutions.
          </p>
        </div>
        <div className="card col-lg-4 p-5">
          <div className="mission_img my-4"></div>
          <p>
            To be a transformative force in the field of IT education and career
            development, enabling individuals to achieve excellence and
            contribute meaningfully to the global technology landscape.
          </p>
        </div>
      </div>
    </div>
  );
};

export default VisionMission;
